import { IQService } from 'angular';
import moment from 'moment';
import { PayrollInvoiceService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';

import templateUrl from './payroll-invoice-generator-container.component.html';

export const PayrollInvoiceGeneratorContainerComponent = {
    controller: PayrollInvoiceGeneratorContainerController,
    controllerAs: "vm",
    templateUrl
};

function PayrollInvoiceGeneratorContainerController($q: IQService, payrollInvoiceService: PayrollInvoiceService,
    utilityService: UtilityService) {
    'ngInject';

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = $onInit;
    vm.totalSaveOperations = 0;
    vm.currentSaveOperations = 0;
    vm.payrollInvoices;
    // Memoize any loaded instances of these resources.
    vm.icdCorporationSet = {};
    vm.creatingAnyInvoices = creatingAnyInvoices;
    vm.onSave = onSave;

    function $onInit() {
        utilityService.showLoading();
        payrollInvoiceService.retrieveNewPayrollInvoices()
            .then(function (invoices) {
                return invoices.sort(function (a, b) {
                    if (a.Owner !== b.Owner) {
                        return a.Owner < b.Owner ? -1 : 1;
                    }
                    if (a.ClientName !== b.ClientName) {
                        return a.ClientName < b.ClientName ? -1 : 1;
                    }
                    // Sort descending by start date.
                    if (a.StartDate !== b.StartDate) {
                        return a.StartDate < b.StartDate ? 1 : -1;
                    }
                    if (a.EndDate !== b.EndDate) {
                        return a.EndDate < b.EndDate ? -1 : 1;
                    }
                    return 0;
                })
            })
            .then(function (invoices) {
                vm.payrollInvoices = invoices;
            })
            .catch(function (ex) {
                console.error(ex);
                alert(utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }

    function onSave() {
        utilityService.showLoading();
        const newInvoices = vm.payrollInvoices.filter(function (invoice) {
            return invoice.IsNew && (!invoice.Adjustment || invoice.AdjustmentComments);
        });
        vm.totalSaveOperations = 1 + newInvoices.length * 2; // Each invoice will be created and then updated.
        vm.currentSaveOperations = 1; // Start with at least operation completed; it skews the progress animation to look better.
        const invoiceDate = moment(vm.invoiceDate).format("YYYY-MM-DD");

        const saveInvoices = newInvoices.map(function (invoice) {
            return payrollInvoiceService.createPayrollInvoice(invoice.PayrollID, invoiceDate)
                .then(function (createdInvoice) {
                    vm.currentSaveOperations++;

                    // Save additional changes to the payroll invoice.
                    createdInvoice.Adjustment = invoice.Adjustment;
                    createdInvoice.AdjustmentComments = invoice.AdjustmentComments;
                    createdInvoice.StatusID = invoice.StatusID;

                    return payrollInvoiceService.updatePayrollInvoice(createdInvoice.PayrollID, createdInvoice);
                })
                .then(function () {
                    vm.currentSaveOperations++;

                    return invoice;
                });
        });

        $q.all(saveInvoices)
            .then(function (v) {
                v.forEach(function (invoice) {
                    // Remove the invoice from the list.
                    vm.payrollInvoices.splice(vm.payrollInvoices.indexOf(invoice), 1);
                })
            })
            .catch(function (ex) {
                console.error(ex);
                alert(utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.totalSaveOperations = 0;
                vm.currentSaveOperations = 0;
                utilityService.hideLoading();
            });
    }

    /*
     * Return whether any invoices are being created.
     */
    function creatingAnyInvoices() {
        return vm.payrollInvoices && vm.payrollInvoices.reduce(function (any, invoice) {
            return any || invoice.IsNew;
        }, false);
    }

}
